import { gql } from "@apollo/client";
export const simrecordsQuery = gql`
query S_SimFormData_ListData( $id: String) {
  aatmsv4_simformrecords(order_by: {date: asc, resulttext: asc},  where: {active: {_eq: true}, published: {_eq: true},trainerid: {_eq: $id } } ) {
  simformname
  traineename
  date
  simrecord
}
}
`;
export const simDashboardMessage = gql`
  query Simulator_dashboard_message($name: String) {
    aatmsv4_clients(where: { clientname: { _eq: $name } }) {
      simulatormessage
    }
  }
`;

export const simDashboardApprovalstatus = gql`
  query Sim_dashboard_approvalstatus($id: String) {
    aatmsv4_simulatorinst(where: { usersid: { _eq: $id } }) {
      instructorapproval
      instvalidity 
      examinerapproval
      examvalidity  
    }
  }
`;
